export default __webpack_public_path__ + "static/media/Screenshot_3.0f052bb2.jpg";